import React from "react";
import PropType from "prop-types";
import { useSelector } from "react-redux";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import UseStyles from "./style";

export default function HeaderBar(props) {
    const internalClasses = UseStyles();
    const { classes, children } = props
    const { Auth } = useSelector((state) => state);
    return (
        <AppBar position="fixed" className={internalClasses.appBar}>
            <Toolbar className={internalClasses.tool}>
                {children}
            </Toolbar>
        </AppBar>

    );
}
HeaderBar.propType = {
    classes: PropType.object.required,
    children: PropType.object.required,
};